import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';
import PracticalTexts from "../PracticalTexts";

export default class Notification extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            buildingId: props.BuildingId,
            caller: props.Caller,
            data: null,
            loading: true,
            messageTemplateId: this.getDefaultGuid(),
            templates: [],
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();

        var p1 = this.httpPost("api/v1/common/getsmstemplate", {
            onlySystemTemplates: false,
            useIn: 'building'
        })
            .then(data => {
                this.state.templates = data.templates;
            });

        var p2 = this.httpPost("api/v1/billnotification/get", {
                id: this.getCurrentFormId(),
                buildingId: this.state.buildingId
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        this.state.data = data;
                    }
                    else {
                        this.showErorrMessage(data.message);
                    }
                });

        Promise.all([p1, p2]).then(r => {
            this.setState({
                loading: false
            })
        });

    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/billnotification/save", {
            id: this.state.id,
            dateStart: this.convertMomentToDb(this.state.data.record.dateStart),
            dateEnd: this.convertMomentToDb(this.state.data.record.dateEnd),
            comment: this.state.data.record.comment,
            title: this.state.data.record.title,
            buildingId: this.state.data.record.buildingId,
            messageTemplateId: this.state.messageTemplateId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    selectTitle() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <PracticalTexts
                    Caller={this}
                    Type={4}
                    OnSelect="onSelectTitle"
                />
            ),
        });

    }
    onSelectTitle(e) {
        this.state.data.record.title = e.text;
        this.setState({ data: this.state.data });
    }
    selectComment() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <PracticalTexts
                    Caller={this}
                    Type={6}
                    OnSelect="onSelectComment"
                />
            ),
        });

    }
    onSelectComment(e) {
        this.state.data.record.comment = e.text;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable">
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات اطلاعیه" : "افزودن اطلاعیه جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12" key={this.state.data.record.title }>
                                        <div className="form-group">
                                            <label for="name" className="title1"><a onClick={e => this.selectTitle()} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>عنوان اطلاعیه</label><span className="red">*</span>
                                            <input type="text" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxLength="400" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">پیامک برای مالک/مستاجر</label>
                                            <select defaultValue={this.state.messageTemplateId} onChange={e => this.state.messageTemplateId = e.target.value} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                {this.state.templates.map(template =>
                                                    <option value={template.id}>{template.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">از تاریخ<span className="red">*</span></label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.dateStart = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.dateStart)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">تا تاریخ<span className="red">*</span></label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.dateEnd = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.dateEnd)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group" key={this.state.data.record.comment }>
                                            <label for="name" className="title1"><a onClick={e => this.selectComment()} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>متن اطلاعیه</label><span className="red">*</span>
                                            <textarea defaultValue={this.state.data.record.comment} onChange={e => this.state.data.record.comment = e.target.value} autocomplete="off" type="text" className="form-control input-sm" style={{ "height":"120px"}}></textarea>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}